var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-gathering-trailer" } },
    [
      _c(
        "el-form",
        {
          staticClass: "section",
          staticStyle: {
            "flex-direction": "row",
            width: "fit-content",
            "min-width": "1345px"
          },
          attrs: { disabled: _vm.readonly }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { no: "landTransportation" },
              on: {
                change: function($event) {
                  return _vm.pm.loadingTermChange("landTransportation")
                }
              },
              model: {
                value: _vm.form.landTransportation,
                callback: function($$v) {
                  _vm.$set(_vm.form, "landTransportation", $$v)
                },
                expression: "form.landTransportation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Partners.doorInformation")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "dischargingPortDoor" },
              model: {
                value: _vm.form.dischargingPortDoor,
                callback: function($$v) {
                  _vm.$set(_vm.form, "dischargingPortDoor", $$v)
                },
                expression: "form.dischargingPortDoor"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DestinationDelivery")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "warehousing" },
              on: {
                change: function($event) {
                  return _vm.pm.loadingTermChange("warehousing")
                }
              },
              model: {
                value: _vm.form.warehousing,
                callback: function($$v) {
                  _vm.$set(_vm.form, "warehousing", $$v)
                },
                expression: "form.warehousing"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.WarehouseLoading")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "customs" },
              on: {
                change: function(val) {
                  _vm.form.customsBroker = val ? _vm.form.customsBroker : 0
                  _vm.form.customsDeclarationType = val
                    ? _vm.form.customsDeclarationType
                    : -1
                }
              },
              model: {
                value: _vm.form.customs,
                callback: function($$v) {
                  _vm.$set(_vm.form, "customs", $$v)
                },
                expression: "form.customs"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "isInsure" },
              model: {
                value: _vm.form.insure,
                callback: function($$v) {
                  _vm.$set(_vm.form, "insure", $$v)
                },
                expression: "form.insure"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
          )
        ],
        1
      ),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "133px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ConsignInfo")))
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.form.jobNo, disabled: true }
                      })
                    ],
                    1
                  ),
                  _vm.isZY
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AllowSaleProduct,
                                filterable: "",
                                no: "allowSaleProduct",
                                clearable: "",
                                "data-filter-function": function(p) {
                                  return p.statusEnabled && p.intergraed
                                },
                                "default-value": _vm.form.saleProductCode || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.saleProductCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_FullOrInside$FULL_OR_INSIDE,
                                no: "fullOrInside",
                                clearable: "",
                                "default-value": _vm.form.fullOrInside || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.fullOrInside = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ConsignationCompany")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sopImageB,
                                expression: "sopImageB"
                              }
                            ],
                            attrs: {
                              content: _vm.$t("SeaExport.SOPReceiver"),
                              placement: "right-end"
                            }
                          },
                          [
                            _c("img", {
                              class:
                                _vm.form.customerId && _vm.readonly
                                  ? ""
                                  : "not-click",
                              staticStyle: {
                                padding: "5px 0",
                                "vertical-align": "bottom",
                                cursor: "pointer"
                              },
                              attrs: {
                                src: _vm.sopPic,
                                width: "18",
                                height: "28"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.sopChangeCustomerIdHandler()
                                }
                              }
                            })
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showWarningImageB,
                                expression: "showWarningImageB"
                              }
                            ],
                            attrs: {
                              content: _vm.warningImageBTip,
                              placement: "right-end"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning red",
                              staticStyle: { cursor: "pointer" }
                            })
                          ]
                        ),
                        _c("cargo-sales-company-select", {
                          ref: "customerSelect",
                          staticClass: "shipper-selector",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "customerId",
                            "popper-class": "shipper-selector-popper",
                            "method-params": {
                              customer: true,
                              active: true,
                              companyLob: "integratedJob"
                            },
                            "check-credit": true,
                            "default-value": _vm.form.customerId || "",
                            disabled: !_vm.customerEnabled,
                            job: _vm.form
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.customerIdChange2ContractHandler(p)
                              _vm.clearPoNo()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerProperty") } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.customerTip,
                            placement: "bottom"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.contractStatus === 2 &&
                                      typeof _vm.customerLevel.level ===
                                        "number") ||
                                    parseInt(_vm.customerLevel.level) > -1,
                                  expression:
                                    "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                }
                              ],
                              staticClass: "orange"
                            },
                            [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.contractStatus === 2 &&
                                      typeof _vm.customerLevel.level ===
                                        "number") ||
                                    parseInt(_vm.customerLevel.level) > -1,
                                  expression:
                                    "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                }
                              ],
                              staticStyle: { color: "#D3A73B" }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.customerLevel.customerName)
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.contractStatusLabel,
                                  expression: "contractStatusLabel"
                                }
                              ],
                              staticClass: "red"
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.contractStatusLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.advancePaymentLabel,
                                  expression: "advancePaymentLabel"
                                }
                              ],
                              staticStyle: { color: "brown" }
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.advancePaymentLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.stampPictureView.businessDocuments
                                      .length > 0,
                                  expression:
                                    "stampPictureView.businessDocuments.length > 0"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  _vm.stampPictureView.visible = true
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { "text-align": "right" },
                                attrs: {
                                  title: _vm.$t("Message.BookingSeal"),
                                  src: _vm.stampIcon,
                                  height: "14"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContactPerson") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "customerContact",
                                filterable: "",
                                "allow-create": true
                              },
                              model: {
                                value: _vm.form.customerContact,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "customerContact", $$v)
                                },
                                expression: "form.customerContact"
                              }
                            },
                            _vm._l(_vm.contactList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.contactPerson,
                                  value: item.contactPerson
                                }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-link",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowContactPersonDetail,
                                  expression: "!isShowContactPersonDetail"
                                }
                              ],
                              class: _vm.form.customerContact
                                ? ""
                                : "not-click",
                              attrs: { no: "customerContactLink" },
                              on: { click: _vm.showContactDialog }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")) + " ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoType,
                          "method-params": { sea: true },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.cargoType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.cargoType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OrderChannels") } },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.form.salesChannel, disabled: true }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ConsignationRelationNumber")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.form.trustFromJob, disabled: true }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "SeaExport.ComprehensiveLogisticsOrderType"
                        )
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            value: _vm.form.containerLoadType,
                            no: "containerLoadType",
                            disabled: _vm.isSelectDisabled || _vm.hasMaster
                          },
                          on: {
                            change: function(val) {
                              _vm.pm.containerLoadTypeChange(val)
                            }
                          }
                        },
                        _vm._l(_vm.containerLoadTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperateType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            value: _vm.form.operateType,
                            disabled: _vm.hasMaster,
                            no: "operateType"
                          },
                          on: {
                            change: function(val) {
                              _vm.pm.operateTypeChange(val)
                            }
                          }
                        },
                        _vm._l(_vm.operateTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TransportType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportType,
                          "method-params": { ie: true },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.transportType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transportType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessDate")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "departure-date-picker",
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            no: "businessDate",
                            value: _vm.form.businessDate,
                            disabled: _vm.provisionEtdLocked,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.businessDateChange }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("filterWeek")(_vm.form.businessDateDay)
                            )
                          )
                        ])
                      ],
                      1
                    ),
                    _vm.provisionEtdLocked
                      ? _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-size": "12px" }
                          },
                          [_vm._v("(已计提校准不可修改)")]
                        )
                      : _vm._e()
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_estEtd")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "departure-date-picker",
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            no: "etd",
                            value: _vm.form.etd,
                            disabled: _vm.hasMaster,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.etdChange }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_actAtd")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            value: _vm.form.atd,
                            disabled: _vm.hasMaster,
                            no: "atd",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.atdChange }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.atdSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_estEta")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            disabled: _vm.hasMaster,
                            no: "eta",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.etaChange },
                          model: {
                            value: _vm.form.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "eta", $$v)
                            },
                            expression: "form.eta"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.etaSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("el-form-item", [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_actAta")))
                    ]),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { flex: "1", "margin-right": "5px" },
                          attrs: {
                            disabled: _vm.hasMaster,
                            no: "ata",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          on: { input: _vm.ataChange },
                          model: {
                            value: _vm.form.ata,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ata", $$v)
                            },
                            expression: "form.ata"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.form.ataSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customsDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsDate", $$v)
                          },
                          expression: "form.customsDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.PlaceOfReceiptCodeOnBl")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "dispatchingPlaceCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          placeholder: _vm.$t("SeaExport.PlaceHolderPOR"),
                          filterable: "",
                          "default-value": _vm.form.dispatchingPlaceCode,
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.changeDispatchingPlaceCode(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_dispatchingPlace")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "dispatchingPlace" },
                        on: {
                          change: function($event) {
                            return _vm.pm.changeDispatchingPlace()
                          }
                        },
                        model: {
                          value: _vm.form.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dispatchingPlace", $$v)
                          },
                          expression: "form.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_loadingPortCode")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          ref: "loadingPortCode",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "loadingPortCode",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            disabled: _vm.hasMaster,
                            filterable: "",
                            "default-value": _vm.form.loadingPortCode,
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.loadingPortCodeCharge(p)
                              _vm.pm.setPlannerChange()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "padding-left": "2px" },
                            attrs: {
                              disabled: _vm.hasMaster,
                              no: "transfering"
                            },
                            model: {
                              value: _vm.form.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transfering", $$v)
                              },
                              expression: "form.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.transfering,
                          expression: "form.transfering"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_transferPortCode")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          disabled: _vm.hasMaster,
                          filterable: "",
                          "default-value": _vm.form.transferPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferPortCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_dischargingPortCode"))
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "dischargingPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          disabled: _vm.hasMaster,
                          filterable: "",
                          "default-value": _vm.form.dischargingPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.dischargingPortCode = p.value
                            _vm.pm.dischargingPortCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_WaybillDestination")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "waybillDestination",
                          type: "textarea",
                          rows: 5
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.changeDispatchingPlace()
                          }
                        },
                        model: {
                          value: _vm.form.waybillDestination,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "waybillDestination", $$v)
                          },
                          expression: "form.waybillDestination"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Carrier") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carrierId",
                          disabled: !_vm.carrierIdEnabled || _vm.hasMaster,
                          "method-params": {
                            truckCmp: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.carrierId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.carrierId = p.value
                            _vm.onCarrierIdChange()
                          },
                          blur: function($event) {
                            return _vm.pm.carrierFocusOutEventHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_PolCountry") } },
                    [
                      _c("el-input", {
                        attrs: { no: "polCountry", disabled: true },
                        model: {
                          value: _vm.form.polCountry,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "polCountry", $$v)
                          },
                          expression: "form.polCountry"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "cargoSource",
                            disabled: !_vm.cargoSourceEnabled,
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          on: {
                            change: function($event) {
                              _vm.form.designationAgent = 0
                              _vm.pm.cargoSourceChange({
                                fieldName: "cargoSource"
                              })
                            }
                          },
                          model: {
                            value: _vm.form.cargoSource,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoSource", $$v)
                            },
                            expression: "form.cargoSource"
                          }
                        },
                        _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _c("cargo-advance-select", {
                        ref: "customJobType",
                        attrs: {
                          no: "customJobType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "default-value": _vm.form.customJobType,
                          "method-params": { type: _vm.form.lob },
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.customJobTypeList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.form.customJobType &&
                  _vm.secondaryCustomJobTypeList.length > 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondaryCustomJobType",
                            attrs: {
                              no: "secondaryCustomJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              cache: false,
                              "default-value": _vm.form.secondaryCustomJobType,
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.secondaryCustomJobTypeList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.secondaryCustomJobType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TransportSource") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          no: "transportSource",
                          "default-value": _vm.form.transportSource,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ServiceStatisticalArea")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          no: "statisticArea",
                          "default-value": _vm.form.statisticArea,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_destinationAgent")
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageC,
                                  expression: "sopImageC"
                                }
                              ],
                              attrs: {
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("img", {
                                class:
                                  _vm.form.destinationAgent && _vm.readonly
                                    ? ""
                                    : "not-click",
                                staticStyle: {
                                  padding: "5px 0",
                                  cursor: "pointer"
                                },
                                attrs: {
                                  src: _vm.sopPic,
                                  width: "18",
                                  height: "28"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.sopChangeHandler()
                                  }
                                }
                              })
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageC,
                                  expression: "showWarningImageC"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageCTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "destinationAgent",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                overseaAgent: true,
                                companyLob: "integratedJob",
                                active: true
                              },
                              "default-value": _vm.form.destinationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.txtDestinationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.cargoSource === "NC",
                          expression: "form.cargoSource === 'NC'"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageA,
                                  expression: "sopImageA"
                                }
                              ],
                              attrs: {
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("div", [
                                _c("img", {
                                  class:
                                    _vm.form.designationAgent && _vm.readonly
                                      ? ""
                                      : "not-click",
                                  staticStyle: {
                                    padding: "5px 0",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    src: _vm.sopPic,
                                    width: "18",
                                    height: "28"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.sopChangeBookingAgentHandler()
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageA,
                                  expression: "showWarningImageA"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageATip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticClass: "designation-agent-selector",
                            attrs: {
                              no: "designationAgent",
                              "popper-class":
                                "designation-agent-selector-popper",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              disabled: !_vm.designationAgentEnabled,
                              "method-params": {
                                designationAgent: true,
                                companyLob: "integratedJob",
                                active: true
                              },
                              "check-credit": true,
                              "default-value": _vm.form.designationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.designationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "bookingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "integratedJob",
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.bookingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.bookingAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_transferAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            portAgent: true,
                            companyLob: "integratedJob",
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.form.transferAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section form-column",
              staticStyle: { width: "400px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "135px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.AdditionalInformation")))
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        id: "customerRefNo",
                        label: _vm.$t("SeaExport.BusinessReferenceNo")
                      }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled: !_vm.customerRefNoTip,
                            content: _vm.customerRefNoTip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.customerRefNoTip ? "red" : "",
                            attrs: { no: "customerRefNo" },
                            on: {
                              blur: function($event) {
                                return _vm.pm.customerRefNoFocusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.form.customerRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerRefNo", $$v)
                              },
                              expression: "form.customerRefNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "poNoClass" : "",
                      attrs: { label: _vm.$t("SeaExport.ItemNo") }
                    },
                    [
                      !_vm.openProjectConfig
                        ? _c("el-input", {
                            attrs: { no: "poNo" },
                            model: {
                              value: _vm.form.poNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "poNo", $$v)
                              },
                              expression: "form.poNo"
                            }
                          })
                        : _vm._e(),
                      _vm.openProjectConfig
                        ? _c("cargo-project-select", {
                            attrs: {
                              no: "poNo",
                              "default-value": _vm.form.poNo,
                              "customer-id": _vm.form.customerId,
                              "is-linked": _vm.isProjectLinkedCustomer
                            },
                            on: {
                              change: function(p) {
                                _vm.form.poNo = p.value
                                _vm.form.projectName = p.projectName
                                _vm.changeProject()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectName") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.projectName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "projectName", $$v)
                              },
                              expression: "form.projectName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ProjectBatch") } },
                        [
                          _c("el-input", {
                            attrs: { no: "projectBatch" },
                            model: {
                              value: _vm.form.projectBatch,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "projectBatch", $$v)
                              },
                              expression: "form.projectBatch"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsBroker",
                          disabled: !_vm.customsBrokerEnabled,
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "data-filter-function": _vm.customsBrokerFilter,
                          filterable: "",
                          "default-value": _vm.form.customsBroker || "",
                          placeholder: !_vm.customsBrokerEnabled
                            ? _vm.$t(
                                "SeaExport.PleaseTickCustomsDeclarationOption"
                              )
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip"),
                          "method-params": {
                            customsBroker: true,
                            companyLob: "integratedJob",
                            active: true
                          }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsBroker = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationType")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled: !_vm.customsBrokerEnabled,
                          "select-type":
                            _vm.selectTypeNames
                              .basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.form.customsDeclarationType === -1
                              ? ""
                              : _vm.form.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsMethodPol",
                          disabled: !_vm.customsBrokerEnabled,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CustomsMode,
                          "method-params": { serviceType: 2 },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.customsMethodPol
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsMethodPol = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "tradeTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          filterable: "",
                          "default-value": _vm.form.tradeTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.tradeTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HaulageCompany") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carryingCmp",
                          disabled: !_vm.form.landTransportation,
                          "method-params": {
                            truckCmp: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.carryingCmp || "",
                          placeholder: !_vm.form.landTransportation
                            ? _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              )
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.carryingCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.openWarehouse
                          ? _vm.$t("SeaExport.WarehouseSupplier")
                          : _vm.$t("SeaExport.Warehouse")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "warehouseCmp",
                          disabled: !_vm.warehouseEabled,
                          "method-params": {
                            warehouse: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.warehouseCmp || "",
                          placeholder: !_vm.warehouseEabled
                            ? _vm.$t("SeaExport.PleaseSelectWarehouse")
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.warehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.openWarehouse
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.WareHouseName") } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "warehouseName",
                              attrs: {
                                no: "warehouseName",
                                disabled:
                                  !_vm.warehouseEabled ||
                                  !_vm.form.warehouseCmp,
                                "allow-create": true,
                                filterable: "",
                                clearable: true
                              },
                              on: { change: _vm.warehouseNameChangeHandler },
                              model: {
                                value: _vm.form.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "warehouseName", $$v)
                                },
                                expression: "form.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.SpecialPriceInstructions")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "salePriceRemarks" },
                        model: {
                          value: _vm.form.salePriceRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "salePriceRemarks", $$v)
                          },
                          expression: "form.salePriceRemarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FreeDemurrage") } },
                    [
                      _c("el-input", {
                        attrs: { no: "freeDemurrage" },
                        model: {
                          value: _vm.form.freeDemurrage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "freeDemurrage", $$v)
                          },
                          expression: "form.freeDemurrage"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FreeDetention") } },
                    [
                      _c("el-input", {
                        attrs: { no: "freeDetention" },
                        model: {
                          value: _vm.form.freeDetention,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "freeDetention", $$v)
                          },
                          expression: "form.freeDetention"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsAreaApplication")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "customsAreaApplication" },
                        model: {
                          value: _vm.form.customsAreaApplication,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsAreaApplication", $$v)
                          },
                          expression: "form.customsAreaApplication"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FreightTerm") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentTermMBL",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentTermMBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField1") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField1",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField1", $$v)
                          },
                          expression: "form.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField2") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField2",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField2", $$v)
                          },
                          expression: "form.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField3") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField3",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField3", $$v)
                          },
                          expression: "form.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField4") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField4",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField4", $$v)
                          },
                          expression: "form.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "taxNature", $$v)
                            },
                            expression: "form.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.QuantityConsignActual")
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantityContract",
                              precision: 0,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.jobContractQwcChange(1)
                              }
                            },
                            model: {
                              value: _vm.form.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityContract", $$v)
                              },
                              expression: "form.quantityContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "quantityActual",
                            attrs: {
                              no: "quantityActual",
                              precision: 0,
                              disabled: _vm.pm.billChargeFlag,
                              min: 0
                            },
                            on: { change: _vm.quantityActualChange },
                            model: {
                              value: _vm.form.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityActual", $$v)
                              },
                              expression: "form.quantityActual"
                            }
                          }),
                          _c("span", [_vm._v("PCS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.WeightConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "weightContract",
                              precision: 3,
                              min: 0
                            },
                            on: { change: _vm.weightContractChange },
                            model: {
                              value: _vm.form.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightContract", $$v)
                              },
                              expression: "form.weightContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "weightActual",
                            attrs: {
                              no: "weightActual",
                              precision: 3,
                              disabled: _vm.pm.billChargeFlag,
                              min: 0
                            },
                            on: { change: _vm.weightActualChange },
                            model: {
                              value: _vm.form.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightActual", $$v)
                              },
                              expression: "form.weightActual"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.CubageConsignActual") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "cubageContract",
                              precision: 3,
                              min: 0
                            },
                            on: { change: _vm.cubageContractChange },
                            model: {
                              value: _vm.form.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageContract", $$v)
                              },
                              expression: "form.cubageContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "cubageActual",
                            attrs: {
                              no: "cubageActual",
                              precision: 3,
                              disabled: !_vm.cubageActualEnabled,
                              min: 0
                            },
                            on: { change: _vm.cubageActualChange },
                            model: {
                              value: _vm.form.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageActual", $$v)
                              },
                              expression: "form.cubageActual"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "packing",
                          "default-value": _vm.form.packing
                        },
                        on: {
                          change: function(p) {
                            _vm.form.packing = p.value
                            _vm.pm.txtPackingChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Pieces") } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "insideQuantity", precision: 0, min: 0 },
                        on: {
                          valCallBack: function(val) {
                            _vm.form.insideQuantity = val
                          }
                        },
                        model: {
                          value: _vm.form.insideQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "insideQuantity", $$v)
                          },
                          expression: "form.insideQuantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PiecesType") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "insidePacking",
                          "default-value": _vm.form.insidePacking
                        },
                        on: {
                          change: function(p) {
                            _vm.form.insidePacking = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "chargeWeight",
                              precision: 3,
                              disabled: !_vm.chargeWeightEnabled,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.chargeWeightChange()
                              }
                            },
                            model: {
                              value: _vm.form.chargeWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "chargeWeight", $$v)
                              },
                              expression: "form.chargeWeight"
                            }
                          }),
                          _c("span", [_vm._v("M/T")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "Copy2", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.transcribeDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Copy2")) + " ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck.cargoEnglishName
                          }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea1",
                            class:
                              _vm.form.cargoEnglishNameWarning === 1
                                ? "red-border"
                                : "",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "cargoEnglishName",
                              "show-count": true,
                              "text-chars": 0,
                              "warning-count": -1,
                              disabled: !_vm.isEdit,
                              "wrap-symbol": "r",
                              "auto-half-word": "",
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                  _vm.form.cargoEnglishName,
                                  function(val) {},
                                  true,
                                  {
                                    autoHalfWord: true,
                                    autoUppercase: _vm.isUppercaseByConfig
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoEnglishName", $$v)
                              },
                              expression: "form.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c(
                        "special-character-tip",
                        { attrs: { texts: _vm.specialCharCheck.mark } },
                        [
                          _c("cargo-rich-textarea", {
                            ref: "cargoTextarea2",
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "mark",
                              "show-count": true,
                              "text-chars": 0,
                              "warning-count": -1,
                              "wrap-symbol": "r",
                              "auto-half-word": "",
                              "auto-uppercase": _vm.isUppercaseByConfig,
                              disabled: !_vm.isEdit
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.form.mark,
                                  function(val) {},
                                  true,
                                  {
                                    autoHalfWord: true,
                                    autoUppercase: _vm.isUppercaseByConfig
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.HsCode")))
                          ]),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: { no: "Search", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showHsCodeSearchDialog(
                                    _vm.$t("Message.SelectHsCode"),
                                    function(p) {
                                      return (_vm.form.hsCode = p.code)
                                    }
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c("el-input", {
                        attrs: { no: "hsCode", type: "textarea", rows: 5 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.HsCode"),
                              _vm.form.hsCode,
                              function(val) {
                                _vm.form.hsCode = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hsCode", $$v)
                          },
                          expression: "form.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                              )
                            )
                          ]),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: {
                                no: "ChineseDescriptionOfGoods",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showHsCodeSearchDialog(
                                    _vm.$t("Message.SelectCargoChineseName"),
                                    function(p) {
                                      return (_vm.form.cargoChineseName =
                                        p.commodityName)
                                    }
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c("cargo-rich-textarea", {
                        class:
                          _vm.form.cargoChineseNameWarning === 1
                            ? "red-border"
                            : "",
                        attrs: {
                          no: "cargoChineseName",
                          disabled: !_vm.isEdit,
                          "auto-uppercase": false,
                          "auto-half-word": false,
                          "wrap-symbol": "r"
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.form.cargoChineseName,
                              function(val) {
                                _vm.form.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoChineseName", $$v)
                          },
                          expression: "form.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_waybillInvoice") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "waybillInvoice",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.waybillInvoice,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "waybillInvoice", $$v)
                          },
                          expression: "form.waybillInvoice"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section form-column" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "108px",
                    "label-position": "right"
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.OperationInfo")))
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))]
                      ),
                      _c("el-input", {
                        attrs: { value: _vm.txtSalesOffice, disabled: true }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "sales",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "sales",
                            disabled: !(
                              _vm.trustFromEditSales || !_vm.form.relatedJob
                            ),
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.form.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.salesPrompt,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.form.salesRecord = p.value
                              _vm.pm.salesChangeHandler(p)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: { no: "provisioned", disabled: true },
                            model: {
                              value: _vm.form.provisioned,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "provisioned", $$v)
                              },
                              expression: "form.provisioned"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")) + " ")]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.form.cargoSalesId || "",
                          "merge-load": true,
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.form.cargoSalesId = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.SalesDepartment")))]
                      ),
                      _c("cargo-department-new-select", {
                        attrs: {
                          no: "salesOffice",
                          disabled: !_vm.form.sales,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": _vm.form.salesOffice,
                          enables: true,
                          "department-id": Number(_vm.form.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "opOffice",
                          disabled:
                            (!_vm.isRegionalCommission &&
                              _vm.pm.isEntrustOrder(true)) ||
                            _vm.opOfficeDisabled,
                          "is-regional-commission": _vm.isRegionalCommission,
                          "office-id": Number(_vm.form.opOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opOffice = p.value
                            _vm.form.opDepartment = 0
                            _vm.opOfficeChargeHandler()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "opDepartment",
                          "office-id": Number(_vm.form.opOffice),
                          enables: true,
                          "department-id": Number(_vm.form.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") } },
                    [
                      _c("cargo-user-select", {
                        ref: "op",
                        attrs: {
                          no: "op",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.form.op || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.op = p.value
                            _vm.pm.txtOPChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrOffice = p.value
                            _vm.form.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("Message.Customer_Service")))
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.form.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.form.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          no: "csr",
                          "method-params": {
                            officeId:
                              _vm.pm.isEntrustOrder ||
                              _vm.form.salesOffice === 1
                                ? _vm.form.opOffice
                                : _vm.form.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.form.csr || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-user-select", {
                        ref: "siteOp",
                        attrs: {
                          no: "siteOp",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.form.siteOP || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.siteOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "overseaOp",
                        attrs: {
                          no: "overseaOp",
                          "default-value": _vm.form.overseaOp || "",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "static-options": _vm.isHC
                            ? null
                            : _vm.overseaAgentUsersList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.overseaOp = p.value
                            _vm.pm.overseaOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.TruckCustomerService") }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "truckCsr",
                        attrs: {
                          no: "truckCsr",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "truckCsr"
                          },
                          "default-value": _vm.form.truckCsr || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.truckCsrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcOffice = p.value
                            _vm.form.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Message.Documentation_Department"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.form.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.form.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          no: "dc",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.form.dc || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerOffice = p.value
                            _vm.form.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.AirlineDepartment")))
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.form.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.form.plannerDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "seaLine"
                          },
                          "default-value": _vm.form.planner || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.form.planner = p.value
                            _vm.pm.txtPlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.form.userDefinedRoleId1 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.form.userDefinedRoleId2 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("special-requests-grid", {
                    ref: "selectedSpecialRequest",
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: {
                      no: "satisfiedRequests",
                      "is-edit": _vm.isEdit,
                      "customer-id": Number(_vm.form.customerId),
                      lob: _vm.form.lob,
                      job: _vm.form
                    },
                    model: {
                      value: _vm.form.satisfiedRequests,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "satisfiedRequests", $$v)
                      },
                      expression: "form.satisfiedRequests"
                    }
                  }),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OperationRequirements")
                      }
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.form.operationContent,
                            placement: "left"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.form.operationContent
                                  ? _vm.form.operationContent.replace(
                                      /[\n]/g,
                                      "</br>"
                                    )
                                  : _vm.$t("SeaExport.NoData")
                              )
                            },
                            slot: "content"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "operationContent",
                              value: _vm.form.operationContent,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.DoubleClickToAddOperationRequirements"
                                  ),
                              type: "textarea",
                              rows: 4
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.selectOperationReqDialog.value =
                                  _vm.form.operationContent
                                _vm.selectOperationReqDialog.visible =
                                  _vm.isEdit
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationTips") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "operationTips",
                          type: "textarea",
                          rows: 4
                        },
                        model: {
                          value: _vm.form.operationTips,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "operationTips", $$v)
                          },
                          expression: "form.operationTips"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.CustomerDeliveryInfo")))
            ]),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "row" } },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      position: "relative",
                      "margin-right": "10px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "50px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("char-count", {
                      attrs: { form: _vm.form, prefix: "shipper" }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                      [
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "175px"
                          },
                          attrs: {
                            no: "shipperId",
                            "method-params": {
                              shipper: true,
                              active: true,
                              companyLob: "integratedJob"
                            },
                            "default-value": _vm.form.shipperId || ""
                          },
                          on: {
                            change: function(data) {
                              _vm.pm.shipperChange(data)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "shipperBillAddress",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.billAddressDialog.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      ],
                      1
                    ),
                    _vm._l(7, function(i) {
                      return _c(
                        "el-form-item",
                        { key: i, attrs: { "label-width": "0" } },
                        [
                          _c("cargo-input", {
                            ref: "shipperLine" + i,
                            refInFor: true,
                            attrs: {
                              no: "shipperLine" + i,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "shipperLine" + i,
                                  i + 1 > 6 ? null : "shipperLine" + (i + 1),
                                  ""
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Shipper"),
                                  _vm.mergeShipperLine(),
                                  _vm.splitShipperLine,
                                  _vm.notUppercaseShipperConsigneNotify,
                                  null
                                )
                              }
                            },
                            model: {
                              value: _vm.form["shipperLine" + i],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine" + i, $$v)
                              },
                              expression: "form['shipperLine'+i]"
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      position: "relative",
                      "margin-right": "10px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "50px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("char-count", {
                      attrs: { form: _vm.form, prefix: "consignee" }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                      [
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "175px"
                          },
                          attrs: {
                            no: "consigneeId",
                            "method-params": {
                              consignee: true,
                              active: true,
                              companyLob: "integratedJob"
                            },
                            "default-value": _vm.form.consigneeId || ""
                          },
                          on: {
                            change: function(data) {
                              _vm.pm.consigneeChange(data)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "consigneeBillAddress",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.billAddressDialog.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      ],
                      1
                    ),
                    _vm._l(7, function(i) {
                      return _c(
                        "el-form-item",
                        { key: i, attrs: { "label-width": "0" } },
                        [
                          _c("cargo-input", {
                            ref: "consigneeLine" + i,
                            refInFor: true,
                            attrs: {
                              no: "consigneeLine" + i,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "consigneeLine" + i,
                                  i + 1 > 6 ? null : "consigneeLine" + (i + 1),
                                  ""
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Consignee"),
                                  _vm.mergeConsigneeLine(),
                                  _vm.splitConsigneeLine,
                                  _vm.notUppercaseShipperConsigneNotify,
                                  null
                                )
                              }
                            },
                            model: {
                              value: _vm.form["consigneeLine" + i],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine" + i, $$v)
                              },
                              expression: "form['consigneeLine'+i]"
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      position: "relative",
                      "margin-right": "10px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "50px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("char-count", {
                      attrs: { form: _vm.form, prefix: "notify" }
                    }),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                      [
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "175px"
                          },
                          attrs: {
                            no: "notifyId",
                            "method-params": {
                              notify: true,
                              active: true,
                              companyLob: "integratedJob"
                            },
                            "default-value": _vm.form.notifyId || ""
                          },
                          on: {
                            change: function(data) {
                              _vm.pm.notifyChange(data)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "noconifyBillAddress",
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.billAddressDialog.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      ],
                      1
                    ),
                    _vm._l(7, function(i) {
                      return _c(
                        "el-form-item",
                        { key: i, attrs: { "label-width": "0" } },
                        [
                          _c("cargo-input", {
                            ref: "notifyLine" + i,
                            refInFor: true,
                            attrs: {
                              no: "notifyLine" + i,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "notifyLine" + i,
                                  i + 1 > 6 ? null : "notifyLine" + (i + 1),
                                  ""
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.NotifyParty"),
                                  _vm.mergeNotifyLine(),
                                  _vm.splitNotifyLine,
                                  _vm.notUppercaseShipperConsigneNotify,
                                  null
                                )
                              }
                            },
                            model: {
                              value: _vm.form["notifyLine" + i],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine" + i, $$v)
                              },
                              expression: "form['notifyLine'+i]"
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "line-height": "28px",
                          "padding-bottom": "10px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.SecondNotifyParty")))]
                    ),
                    _c("cargo-rich-textarea", {
                      staticStyle: { width: "310px", height: "230px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "alsoNotify",
                        "text-chars": 0
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.SecondNotifyParty"),
                            _vm.form.alsoNotify,
                            function(val) {
                              _vm.form.alsoNotify = val
                            },
                            _vm.notUppercaseShipperConsigneNotify,
                            null
                          )
                        }
                      },
                      model: {
                        value: _vm.form.alsoNotify,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "alsoNotify", $$v)
                        },
                        expression: "form.alsoNotify"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "ContactPerson",
            visible: _vm.contactDialog.visible,
            title: _vm.$t("SeaExport.ContactPerson"),
            width: "400px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.contactDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.contactPerson
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.role
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.telephone
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.mobile
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: { disabled: true, value: _vm.contactDialog.data.fax }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.email
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.remarks,
                      type: "textarea",
                      rows: 3
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sop-dialog", {
        attrs: {
          visible: _vm.sopDialog.visible,
          "cmp-idx": _vm.sopDialog.cmpIdx,
          job: _vm.form,
          agent: _vm.sopDialog.agent,
          lob: "SE",
          "contact-list": _vm.sopDialog.contactList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopDialog, "visible", $event)
          },
          updateJob: function($event) {
            return _vm.$emit("updateJob")
          }
        }
      }),
      _c("transcribe-dialog", {
        attrs: { visible: _vm.transcribeDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transcribeDialog, "visible", $event)
          },
          callback: _vm.transcribeCallback
        }
      }),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      }),
      _c("select-operation-req-dialog", {
        attrs: {
          visible: _vm.selectOperationReqDialog.visible,
          lob: "SE",
          value: _vm.selectOperationReqDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
          },
          callback: function(val) {
            return (_vm.form.operationContent = val)
          }
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }